import { render, staticRenderFns } from "./DetailsDialog.vue?vue&type=template&id=68f5c2a1&"
import script from "./DetailsDialog.vue?vue&type=script&lang=ts&"
export * from "./DetailsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports